export enum CommentsActionsEnum {
	GET_COMMENTS = '[Comments Api] Get Comments ',
	ADD_COMMENT = '[Comments Api] Add Comment',
	REMOVE_COMMENT = '[Comments Api] Remove Comment',
	UPDATE_COMMENT = '[Comments Api] Update Comment',
}
